import type { SecureStorageItems } from "./types";

export const SecureStorageItemTypes: Record<
  keyof SecureStorageItems,
  "string" | "number" | "boolean" | "object"
> = {
  "device.id": "string",
  "auth.accessToken": "string",
  "auth.refreshToken": "string",
  "auth.userId": "string",
};
